import { httpRequest } from "@/utils/HttpRequest";
import { IPage } from "@/types/ScmTypes";
import { IInquiryGoodsResultSave, IInquiryGoodsResultSaveDetail, IInquiryResultDetail, IInquiryResultSearchFields } from "./inquiryResultTypes";


class InquiryResultService {
    //保存
    async save(params: IInquiryGoodsResultSave) {
        const apiUrl = "/sum/result/insert";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //列表
    async page(params: IInquiryResultSearchFields) {
        const apiUrl = "/sum/result/findPage";
        return await httpRequest.post<IPage<IInquiryResultDetail>>(apiUrl, params);
    }
     //单条
    async one(id: string) {
        const apiUrl = `/sum/result/one/${id}`;
        return await httpRequest.get<IInquiryGoodsResultSave>(apiUrl);
    }

     //导出
    async exportTemplate(params:{resultCode: string}) {
        const apiUrl = `/sum/result/details/export`;
        return await httpRequest.postFile(apiUrl,params);
    }

    

    
   
  
}

export const inquiryResultService = new InquiryResultService();
